// Librairies
import { v4 as uuidv4 } from 'uuid';

export default class TasksUtil {
    static createRequest({ id = uuidv4(), functionName, toastId, processMessageId, successMessageId, errorMessageId, customProps = {} } = {}) {
        return {
            id, functionName, status: 0, toastId, processMessageId, successMessageId, errorMessageId, date: new Date(), ...customProps
        }
    }

    static async sendRequests(requests, setRequest) {
        if (requests.length === 0) return;
        setRequest({ ...requests[0], requestsQueue: requests.slice(1) });
    }
}